module.exports = {
      id: "question-usage",
      viewBox: "0 0 29 29",
      url: __webpack_public_path__ + "sprite-84b14bdf361f52431cd97a9452f94b75.svg#question",
      toString: function () {
        return this.url;
      }
    }